interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  children: React.ReactNode;
}

export const Modal = ({ isOpen, handleClose, children }: IProps) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed-modal">
        <div className="box-modal">
          <div className="close-modal">
            <button onClick={handleClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};
